import { render, staticRenderFns } from "./ValidationHeader.vue?vue&type=template&id=66ccce2a&scoped=true&"
import script from "./ValidationHeader.vue?vue&type=script&lang=js&"
export * from "./ValidationHeader.vue?vue&type=script&lang=js&"
import style0 from "./ValidationHeader.vue?vue&type=style&index=0&id=66ccce2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ccce2a",
  null
  
)

export default component.exports